const InvestmentsChallenge1HintsText =
    ["There are 6 items in the 'Statements are False' column " +
        "that should be moved to the 'Statements are True' column.",
     "One of the statements calls out a key difference between " +
        "index funds and mutual funds.  Index funds do not have a money manager.",
     "Only invest money that you won't need for the forseeable future. ",
     "There are a lot of stocks, mutual funds, index funds and bonds that you can likely " +
        "you can likely afford even if you only have $200 to $500 to invest." 
    ]
   

export default InvestmentsChallenge1HintsText;